import { render, staticRenderFns } from "./InsuranceSubprogramDetail.vue?vue&type=template&id=b98825da&scoped=true"
import script from "./InsuranceSubprogramDetail.vue?vue&type=script&lang=js"
export * from "./InsuranceSubprogramDetail.vue?vue&type=script&lang=js"
import style0 from "./InsuranceSubprogramDetail.vue?vue&type=style&index=0&id=b98825da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98825da",
  null
  
)

export default component.exports